<template>
    <div data-testid="ar-dashboard-pending-payment-followups">
        <v-card outlined class="outlined mb-6 elevation-0 rounded-lg">
          <v-toolbar
      color="transparent"
      flat
      class="text-h5 mb-2 rounded-0 py-1"
    >
                <span v-if="!searchOn">
                    Pending Payment Follow-Up Calls
                </span>
                <v-layout v-else class="mt-4">
                <v-autocomplete
                    data-testid="pending-facility-menu"
                    class="pending-facility-menu"
                    v-model="selectedLocation"
                    label="Filter by location code..."
                    align-with-title
                    persistent-hint
                    clearable
                    :hint="!selectedLocation ? 'Enter or select a location code' : 'Click X to reset the list'"
                    :items="facilityCodes"
                />
                </v-layout>
                <v-spacer />
                <v-btn
                    data-testid="pending-search-btn"
                    class="pending-search-btn"
                    icon
                    @click="searchOn = !searchOn"
                >
                    <v-icon>search</v-icon>
                </v-btn>
            </v-toolbar>
            <transition name="fade-transition" mode="out-in">
                <v-layout
                    v-if="loading"
                    justify-center
                    key="load-state"
                    data-testid="load-state"
                >
                    <v-progress-circular
                        :size="60"
                        :width="6"
                        indeterminate
                        class="my-4"
                    />
                </v-layout>
                <v-layout
                    class="ma-4 text-h6 font-weight-regular"
                    v-else-if="!pendingPayments.length"
                    key="no-pending-payments"
                    data-testid="no-pending-payments"
                >
                    No pending payments found.
                </v-layout>
                <v-list
                    v-else
                    two-line
                    style="max-height: 600px; overflow-y:auto;"
                    key="pending-list"
                    class="my-1"
                    data-testid="pending-list"
                >
                    <v-list-item
                        v-for="(pendingPayment, i) in filteredPendingPayments"
                        :key="i"
                        class="px-0"
                    >
                        <div style="width: 100%">
                            <v-list-item-content>
                                <v-list-item-title class="mt-1" data-testid="pending-payment-name">
                                    {{ pendingPayment.tenant.first_name }} {{ pendingPayment.tenant.last_name }}
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    <v-layout justify-space-between align-center>
                                        <v-flex xs2>
                                            <v-icon
                                                class="mr-1"
                                                size="14px"
                                                color="info"
                                            >phone</v-icon>
                                            <span class="text-caption" data-testid="phone-number">
                                                {{ pendingPayment.tenant.phone }}
                                            </span>
                                        </v-flex>
                                        <v-flex xs1>
                                            <v-icon
                                                class="mr-1"
                                                size="14px"
                                                color="success"
                                            >business</v-icon>
                                            <span class="text-caption" data-testid="location-code">
                                                {{ pendingPayment.facility.location_code }}
                                            </span>
                                        </v-flex>
                                        <v-flex xs3>
                                            <span class="error--text text-caption ml-2">Payment Due:</span>
                                            <span class="text-caption" data-testid="payment-date">
                                                {{ formatDate(pendingPayment.payment_date.date) }}
                                            </span>
                                        </v-flex>
                                        <v-flex xs2 class="ml-2">
                                            <span class="info--text text-caption" data-testid="plan-type">
                                                {{ pendingPayment.payment_plan ? 'Payment Plan' : 'Promise-to-Pay' }}
                                            </span>
                                        </v-flex>
                                        <v-flex
                                            :xs2="!drawer"
                                            :xs1="drawer"
                                            :style="!drawer ? 'padding-right: 6.35rem' : ''"
                                        >
                                            <v-btn
                                                data-testid="pending-call-btn"
                                                class="pending-call-btn px-0 ml-0 mr-3"
                                                small
                                                :icon="drawer"
                                                :text="drawer"
                                                color="primary"
                                                style="height: 1.75rem"
                                                @click="openCallModal(pendingPayment)"
                                            >
                                                <v-icon small v-if="drawer">call_made</v-icon>
                                                <span v-else>Call</span>
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-divider />
                        </div>
                    </v-list-item>
                </v-list>
            </transition>
        </v-card>

        <application-modal
            v-model="callModal"
            @cancel="callModal = false"
        >
            <div slot="modal-title">Initiate Pending Payment Follow-Up Call</div>
            <div slot="modal-body" style="min-height: 25rem">
                <call-modal-content
                    v-if="callModal && callData"
                    :callData="callData"
                    v-model="callId"
                />
            </div>
            <v-btn
                data-testid="pending-begin-call-btn"
                class="pending-begin-call-btn primary"
                slot="create-button"
                :disabled="!callId"
                :loading="loading"
                @click="beginCall"
            >Begin Call</v-btn>
        </application-modal>
    </div>
</template>

<script>
import ApplicationModal from "@/components/ApplicationModal";
import CallModalContent from "@/components/CallModalContent";
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "FailedTable",
  components: { CallModalContent, ApplicationModal },
  data() {
    return {
      callData: "",
      callId: "",
      callModal: false,
      loading: false,
      searchOn: false,
      selectedLocation: ""
    };
  },

  methods: {
    openCallModal(pendingPayment) {
      let callData = {
        tenant_id: pendingPayment.payment_plan ? pendingPayment.payment_plan.tenant_id : pendingPayment.tenant.id,
        ledger_id: pendingPayment.ledger.id,
        name: pendingPayment.payment_plan
          ? pendingPayment.payment_plan.first_name + " " + pendingPayment.payment_plan.last_name
          : pendingPayment.tenant.first_name + " " + pendingPayment.tenant.last_name,
        phone_home: pendingPayment.payment_plan ? pendingPayment.payment_plan.phone : pendingPayment.tenant.phone,
        phone_mobile: "",
        email: pendingPayment.payment_plan ? pendingPayment.payment_plan.email : pendingPayment.tenant.email,
        moved_in: pendingPayment.ledger.moved_in,
        auction_date: {
          date: pendingPayment.ledger.auction_date
        },
        unit_name: pendingPayment.unit.number,
        unit_id: pendingPayment.unit.id,
        unit_type: pendingPayment.unit.type,
        unit_size: pendingPayment.unit.size,
        facility_id: pendingPayment.facility.id,
        facility_name: pendingPayment.facility.name,
        facility_location_code: pendingPayment.facility.location_code,
        facility_street_address: pendingPayment.facility.street_address,
        facility_city: pendingPayment.facility.city,
        facility_state: pendingPayment.facility.state,
        facility_postal_code: pendingPayment.facility.postal_code,
        facility_phone: pendingPayment.facility.phone
      };
      this.callModal = true;
      this.callData = callData;
    },

    beginCall() {
      let createCallPayload = {
        ctm_id: parseFloat(this.callId),
        call_type: "accounts-receivable",
        location_code: this.callData.facility_location_code,
        tenant_id: this.callData.tenant_id
      };
      this.loading = true;

      this.$store.dispatch("beginCall", createCallPayload)
        .then(resp => {
          let routeCallPayload = {
            locationCode: null,
            reservationId: null,
            callId: resp.data.call.id,
            ctm_id: createCallPayload.ctm_id,
            call_type: createCallPayload.call_type,
            router: {
              tenantId: createCallPayload.tenant_id,
              facilityId: this.callData.facility_id
            },
            contact_id: null
          };
          this.$store.commit("setArData");
          this.$store.dispatch("routeCall", routeCallPayload);
        })
        .catch(err => {
          this.$store.dispatch("handleError", err);
          this.loading = false;
        });
    },

    formatDate(date) {
      return moment(date).format("MM/DD/YYYY");
    }
  },

  computed: {
    ...mapState({
      drawer: state => state.application.settings.drawer,
      pendingPayments: state => state.accountsReceivable.pendingPayments
    }),

    filteredPendingPayments() {
      if (this.selectedLocation) {
        return this.pendingPayments.filter(payment => payment.facility.location_code === this.selectedLocation);
      } else {
        return this.pendingPayments;
      }
    },

    facilityCodes() {
      if (this.pendingPayments && this.pendingPayments.length) {
        const facilityCodes = this.pendingPayments.map(pendingPayment => pendingPayment.facility.location_code);
        return [...new Set(facilityCodes)];
      } else {
        return [];
      }
    }
  },

  created() {
    this.loading = true;
    this.$store.dispatch("getPendingPayments")
      .then(() => {
        this.loading = false;
      })
      .catch(err => {
        this.loading = false;
        this.$store.dispatch("handleError", err);
      });
  }
};
</script>
